export const weekDays: Record<uui.domain.WeekStartsOn, number> = {
  su: 0,
  mo: 1,
  tu: 2,
  we: 3,
  th: 4,
  fr: 5,
  sa: 6,
}
